import React, { useEffect, useState, useContext } from "react";
import {
  Tooltip,
  IconButton,
  Grid,
  Switch,
  FormControl,
  Select,
  MenuItem,
  Radio,
  RadioGroup,
  FormControlLabel,
  makeStyles,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import axios from "axios";
import SelectAllIcon from '@material-ui/icons/SelectAll';
import Modal from "../../../cm_shared/cm_global_modal";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import CustomPagination from "./../../../cm_shared/CMCustomPagination/index";
import CheckCircleSharpIcon from "@material-ui/icons/CheckCircleSharp";
import WarningIcon from "@material-ui/icons/Warning";
import { LoadingContext } from "../../../../../context/spinnerContext";
import PRLogicalBasedScenarios from './PRLogicalBasedScenarios'
import VariationsSelection from "../../../cm_close_loop/ScenarioListing/selectVariation";

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
      minHeight: "unset",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "flex-start",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "flex-start",
    },
  },
};
const useStyles = makeStyles({
  label: {
    fontSize: 14, // change the font size to 16px
  },
});

const handleNaN = (value, defaultValue = "N/A") => {
  if (value === null || value === undefined) {
    return defaultValue;
  }
  if (typeof value === "number" && Number.isNaN(value)) {
    return defaultValue;
  }
  return value;
};

const StyledDataTable = styled(DataTable)`
  .rdt_TableBody {
    overflow: auto;
    max-height: calc(100vh - 390px);
  }
`;

function ReportingModePGScenarioListing(props) {
  const classes = useStyles();
  const { setIsLoading } = useContext(LoadingContext);
  const rowsPerPageSessionBased = [10, 20, 50, 100, 200, 300, 500];
  // region option - don't delete this commented code
  // const [radioVal, setRadioVal] = useState("EUR");
  // const [regions, setRegions] = useState([
  //   {
  //     value: "EUR",
  //     label: "EUR",
  //   },
  //   {
  //     value: "JPN",
  //     label: "JPN",
  //   },
  //   {
  //     value: "USA",
  //     label: "USA",
  //   },
  // ]);
  const [sortField, setSortField] = useState("")
  const [sortOrder, setSortOrder] = useState("")
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalForVariation, setModalForVariation] = useState(false);

  const handleSort = (column, direction) => {
    setSortField(column.selector);
    setSortOrder(direction);
  };

  const handleModal = (content, forVariationSelection = false) => {
    setModalContent(content);
    setIsOpen(true);
    forVariationSelection && setModalForVariation(true);
  };

  const restCols = [
    {
      name: "Updated At",
      selector: "updated_at",
      sortable: true,
      cell: (row) => {
        return <span>{row.updated_at}</span>;
      },
    },
    {
      name: "Actions",
      selector: "actions",
      sortable: false,
      width: "200px",
      cell: (row) => {
        const isInCart = props.cartItems.some(
          (item) => item.scenario_uuid === row.scenario_uuid
        );
        return (
          <div>
            {type === 'pg' ?
            <Tooltip
              placement="top"
              title={
                isInCart ? <h6>Remove from Cart</h6> : <h6>Add to Cart</h6>
              }
            >
              <IconButton
                aria-label={isInCart ? "remove" : "add"}
                disabled={statusValue === "bad"}
                onClick={() =>
                  isInCart ? props.removeFromCart(row) : props.addToCart(row)
                }
              >
                {isInCart ? <RemoveCircleIcon /> : <AddIcon />}
              </IconButton>
            </Tooltip> :
            <Tooltip placement="top" title={<h6>Select Scenarios</h6>}>
            <IconButton
              onClick={() => handleModal(
                <VariationsSelection
                  logicalName={row.date_from_folder}
                  getVariations={proceedToGetVariations}
                  closeKapDailog={onClickClose}
                />,
                true
              )}
            >
              <SelectAllIcon />
            </IconButton>
            </Tooltip> }
          </div>
        );
      },
    },
  ];
  const satusOpts = [
    {
      _id: "approved",
      value: "Good",
    },
    {
      _id: "bad",
      value: "Bad",
    },
  ];
  const [columns, setColumns] = useState([]);
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(100);
  const [tableData, setTableData] = useState([]);
  const [fctwSelected, setFctwSelected] = useState(false);
  const [statusValue, setStatusValue] = useState("approved");
  const type = props.type;
  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleMappedChange = (event) => {
    const newSelectValue = event.target.value;
    setStatusValue(newSelectValue);
    setPage(0);
    props.emptyCart([]);
    props.onChangeStatus(newSelectValue);
  };

  // select region radio code - don't delete this commented code
  // const handleRadioChange = (event) => {
  //   const newRadioValue = event.target.value;
  //   console.log(("new radio val", newRadioValue));
  //   setRadioVal(newRadioValue);
  //   props.setRegionValue(newRadioValue);
  // };

  const handleFctwToggle = (event) => {
    console.log("event.target.checked", event.target.checked);
    setFctwSelected(event.target.checked);
    props.emptyCart([]);
    props.onChangeFctw(event.target.checked);
    setPage(0);
  };

  const onClickClose = () => {
    setIsOpen(false);
    setModalForVariation(false);
  }

  const getTableData = async () => {
    try {
      setIsLoading(true);
      const searchOptions = JSON.parse(JSON.stringify(props.searchOpts));
      searchOptions[0].quality_check_status = [statusValue];
      const response = await axios.post(
        type === "pg" ? "/cm/reporting-mode/listing-pg" : "/cm/reporting-mode/pr-listing-by-date",
        {
          searchOptions	: JSON.stringify(searchOptions),
          ...(type === 'pg') && {fctw: fctwSelected},
          page_number_record: page + 1,
          page_size_record: eventsPerPage,
          sort_field_record: sortField,
          sort_order_record: sortOrder
        //  ...(type === 'pr') && {region: radioVal}
        }
      );
      setTableData(response.data.data);
      setTotal(response.data.total_records);
    } catch (err) {
      console.error("error", err);
    } finally {
      setIsLoading(false);
    }
  };

  const proceedToGetVariations = async (count, date) => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        "cm/reporting-mode/pr-listing",
        {
          page_number_record: 1,
          page_size_record: count === 'all' ? count : parseInt(count),
          timestamp: date
      });
      const arrItems = [...props.cartItems, ...response.data.data];
      const uniqueItems = Array.from(
        new Map(arrItems.map(item => [item.scenario_uuid, item])).values()
      );
      props.addToCart(uniqueItems, true);
      onClickClose();
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    props.selectValue && getTableData();
  }, [eventsPerPage, page, props.selectValue, statusValue, fctwSelected, sortField, sortOrder]);

  useEffect(() => {
    // here if will set PG columns else block will set PR column,
    if (type === "pg") {
      const columns = [
        {
          name: "Name",
          selector: "scenario_name",
          sortable: true,
          grow: 2,
          cell: (row) => <div>{row.scenario_name}</div>,
        },
        {
          name: "Scenario Version",
          selector: "scenario_version",
          sortable: true,
        },
        {
          name: "Mapped Status",
          selector: "input_scenario_mapping",
          sortable: true,
          cell: (row) => (
            <div style={{ display: "flex" }}>
              {row.input_scenario_mapping ? (
                <CheckCircleSharpIcon style={{ color: "#b0ff45" }} />
              ) : (
                <Tooltip
                  placement="top"
                  title={<h6>Input scenario not mapped</h6>}
                >
                  <WarningIcon style={{ color: "#ffcc00" }} />
                </Tooltip>
              )}
            </div>
          ),
        },
        {
          name: "Remark",
          selector: "remark",
          sortable: true,
          cell: (row) => (
            <div style={{ display: "flex" }}>
              {row.remark.length > 100 ? (
                <Tooltip placement="top" title={<h6>{row.remark}</h6>}>
                  <span>{`${handleNaN(row.remark).substring(0, 49)}....`}</span>
                </Tooltip>
              ) : (
                <span>{handleNaN(row.remark)}</span>
              )}
            </div>
          ),
        },
        ...restCols,
      ];
      setColumns(columns);
    } else {
      const columns = [
        {
          name: "Date",
          selector: "date_from_folder",
          sortable: true,
          cell: (row) => <div>{row.date_from_folder}</div>,
        },
        {
          name: "Count",
          selector: "count",
          sortable: true,
        },
        ...restCols,
      ];
      setColumns(columns);
    }
  }, [props.cartItems]);

  return (
    <div
      style={{
        padding: "1rem",
        position: "relative",
        borderRadius: "10px",
        height: "calc(100% - 120px)",
      }}
    >
      <Modal
        title={modalForVariation && 'Add count'}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={modalForVariation ? "sm" : "lg"}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        heightVal={modalForVariation ? '350px' : '580px'}
      />
      <div style={{ display: "flex", marginBottom: "10px" }}>
        {/* {type === "pr" && <FormControl
          variant="outlined"
          style={{ minWidth: 100, marginBottom: "10px" }}
        >
          <RadioGroup
            aria-label="quiz"
            name="quiz"
            value={radioVal}
            onChange={handleRadioChange}
            style={{ flexDirection: "row" }}
          >
            {regions.map((item) => (
              <FormControlLabel
                classes={{ label: classes.label }}
                value={item.value}
                control={<Radio />}
                label={item.label}
              />
            ))}
          </RadioGroup>
        </FormControl>} */}
        <FormControl
          variant="outlined"
          style={{ minWidth: 200, marginBottom: "10px" }}
        >
          <Select
            value={statusValue}
            onChange={handleMappedChange}
            MenuProps={{
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
            }}
            style={{ height: "40px" }}
          >
            {satusOpts.map((option) => (
              <MenuItem key={option._id} value={option._id}>
                {option.value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {type === "pg" && (
          <FormControlLabel
            style={{
              border: "1px solid rgba(0,0,0,.2)",
              height: "40px",
              width: "135px",
              borderRadius: "5px",
              padding: "0.5rem",
            }}
            value="start"
            control={
              <Switch
                checked={fctwSelected}
                onChange={handleFctwToggle}
                color="primary"
                name="fctw"
              />
            }
            label="FCTW"
            labelPlacement="start"
          />
        )}
      </div>
      <Grid
        container
        spacing={3}
        style={{
          justifyContent: "end",
        }}
      >
        <Grid item style={{ marginTop: "-8rem"}}>
          <CustomPagination
            total={total}
            rowsPerPageOptions={rowsPerPageSessionBased}
            eventsPerPage={eventsPerPage}
            page={page}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            onPageChange={handlePageChange}
          />
        </Grid>
      </Grid>
      <StyledDataTable
        style={{ marginTop: "1rem" }}
        columns={columns}
        data={tableData}
        onSort={handleSort}
        sortServer
        customStyles={customStyles}
        expandableRowsComponent={
          <PRLogicalBasedScenarios
            cartItems={props.cartItems}
            addToCart={props.addToCart}
            removeFromCart={props.removeFromCart}
            statusValue={statusValue}
          />
        }
        expandableRows={type === 'pr'}
      ></StyledDataTable>
    </div>
  );
}

export default ReportingModePGScenarioListing;
